﻿import {hasFlag, translation} from "@2d-front-monorepo/core";
import {
	AttachmentsComponent, DriverId,
	DriverResult,
	EntityHistoryStatusComponent,
	PermitFullEntityResult, DriverPropertyFlags
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {API_ENDPOINT} from "../../../api-endpoint";

const filesPrefix = API_ENDPOINT.fileDownload;

export function DriverComponent({driver, hiddenEntityProperties, showStatus}: {
	driver: PermitFullEntityResult<DriverId, DriverResult>,
	hiddenEntityProperties: DriverPropertyFlags,
	showStatus: boolean
}): JSX.Element {
	return <div className="card card--driver">
		<header className="layout horizontal aligned middle">
			<h5 className="flex">{translation(PermitTranslations.driver)}</h5>
			{showStatus && <EntityHistoryStatusComponent status={driver}/>}
		</header>
		<hr className="no-margin"/>
		<div className="grid padded">
			{!hasFlag(hiddenEntityProperties, DriverPropertyFlags.Fullname) &&
                <dl className="title-desc col-1of2">
                    <dt>{translation(PermitTranslations.driver__full_name)}</dt>
                    <dd>{driver.entity.fullName}</dd>
                </dl>
			}
			{!hasFlag(hiddenEntityProperties, DriverPropertyFlags.LicenseNumber) &&
                <dl className="title-desc col-1of4">
                    <dt>{translation(PermitTranslations.driver__license_number)}</dt>
                    <dd>{driver.entity.licenseNumber}</dd>
                </dl>
			}
			<AttachmentsComponent entity={driver.entity} linkPrefix={filesPrefix} className="col-1of4"/>
		</div>
	</div>
}
